var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('SvgAssets'),_c('MainHeader',{attrs:{"lang":_vm.lang}}),_c('router-view',{staticClass:"mainFont",class:{ 'eng': _vm.engflg }}),_c('MainFooter',{attrs:{"lang":_vm.lang}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }